import { Routes, Route } from 'react-router-dom';

// Vistas
import Err500 from './pages/error/500/Err500';
import Module from './pages/views/Module';

export default function AppRoutes() {
    return (
        <Routes>
            <Route path="/500" element={
                <Err500 />
            } />

            {/* Ruta principal para acceder a las vistas internas */}
            <Route path="/*" element={
                <Module />
            } /> 
        </Routes>
    )
}